
  // MAKE SURE TO UPDATE setWeek.ts if you change this file!!!!

  export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "prod";
  export const CURRENT_WEEK = 5;
  